import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Link, useParams } from "react-router-dom";
import _ from "lodash";
import classnames from "classnames";

import { isSBReportingLicensed } from "../../store/settings/settings.selectors";
import { withLayout } from "../../components/layout/Layout";
import { withPageName } from "../../components/layout/horizontalMenu/PageName";
import { Icon } from "../../components/icon/Icon";
import { DrilldownTable, DrilldownTitle, DrilldownChart } from "./components";
import { DrilldownRoutePage } from "./drilldown.types";
import { AriaPageTitle } from "../../components/ariaPageTitle";
import { changeProfile } from "../../store/reports/reports.actions";
import { fetchThreats } from "../../store/threats";

import "./DrilldownPage.scss";

type RouteParams = {
  page: DrilldownRoutePage;
};

export const DrilldownPage = () => {
  const { page } = useParams<RouteParams>();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(changeProfile("all_profiles"));

    if (page === DrilldownRoutePage.Botnet) {
      dispatch(fetchThreats());
    }
  }, [dispatch, page]);

  const isLicensed: boolean = useSelector(isSBReportingLicensed);

  if (!isLicensed) {
    return <Navigate to="/home" />;
  }

  return (
    <section className={classnames("drilldowns", page)}>
      <AriaPageTitle pageKey={`page_title_drilldown_${page}`} />
      <DrilldownTitle page={page} />
      <DrilldownChart page={page} />
      <DrilldownTable className="drilldowns__table" page={page} />
    </section>
  );
};

const pageNameContent = (
  <div className="drilldowns__header">
    <Link className="link--with-icon" to="/home">
      <Icon icon="fa-regular fa-angle-left" />
      <span>
        <FormattedMessage id="back_to_dashboard" />
      </span>
    </Link>
    <h1>
      <FormattedMessage id="blocked_reports" />
    </h1>
  </div>
);

export default _.flowRight(
  withLayout(),
  withPageName(pageNameContent)
)(DrilldownPage);
